import type { FaireProductEntity } from "../../entity_types/product";

export const p_karzbrz5h7: FaireProductEntity = {
  token: "p_karzbrz5h7",
  type: "product",
  name: "I AM Blessed Travel Tin",
  brandName: "Freedom Studios",
  imageUrl:
    "https://cdn.faire.com/fastly/6f2d08dd2ce0b7e42446b4bb23129705534518d3b45b613e3410454cda551f05.jpeg",
  priceDollars: 5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/95d46f5d97745ee5525880d91ed0be280ff1a19560cd5eab0d713548bea4873a.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
